"use strict";

exports.unit = {};



//////////////////
// WEBPACK FOOTER
// ../bower_components/purescript-prelude/src/Data/Unit.js
// module id = 91
// module chunks = 0